module.exports = __webpack_public_path__ + "static/media/LEOlogo.7572c37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/LEOlogo.png
// module id = 122
// module chunks = 0